import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { HERO_PHRASES, HERO_PINS } from '../../data/siteData';
import { prefersReducedMotion } from '../../hooks/useMotion';

const RotatingPhrase = () => {
  const [{ index, prev }, setState] = useState({ index: 0, prev: null });

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const id = setInterval(() => {
      setState((s) => ({ prev: s.index, index: (s.index + 1) % HERO_PHRASES.length }));
    }, 2800);
    return () => clearInterval(id);
  }, []);

  return (
    <span className="rot" aria-live="off">
      {HERO_PHRASES.map((phrase, i) => {
        let cls = 'next';
        if (i === index) cls = '';
        else if (i === prev) cls = 'out';
        return (
          <span key={phrase} className={cls} aria-hidden={i !== index}>
            {phrase}
          </span>
        );
      })}
    </span>
  );
};

export const Hero = () => {
  const figRef = useRef(null);
  const [tilt, setTilt] = useState('');
  const [openPin, setOpenPin] = useState(null);
  const canTilt =
    typeof window !== 'undefined' && window.matchMedia?.('(hover: hover)').matches && !prefersReducedMotion();

  const onMove = (e) => {
    if (!canTilt || !figRef.current) return;
    const r = figRef.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    setTilt(`rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`);
  };

  return (
    <section className="hero grid-bg" data-testid="hero-section">
      <div className="wrap">
        <div>
          <div className="mono">BIM Modeling · Scan to BIM · Training</div>
          <h1>
            Coordinated models. <RotatingPhrase />
          </h1>
          <p className="lead">
            BuildiTech is a BIM engineering consultancy helping AEC teams deliver coordinated, data-driven
            construction projects with reliable BIM workflows.
          </p>
          <div className="ctas">
            <Link to="/contact" className="btn btn-p" data-testid="hero-cta">
              Start with a pilot package <span className="ar">→</span>
            </Link>
            <Link to="/projects" className="btn btn-g">View case studies</Link>
          </div>
          <div className="meta">
            <div><b>Dedicated</b>Client interface</div>
            <div><b>India</b>BIM production</div>
            <div><b>3-step</b>QA/QC review</div>
          </div>
        </div>

        <div className="fig" ref={figRef} onMouseMove={onMove} onMouseLeave={() => setTilt('')}>
          <div className="dim"><i /><span>ARCH · STR · MEP — federated model</span></div>
          <div className="vdim" />
          <div className="tilt" style={tilt ? { transform: tilt } : undefined}>
            <img src="/images/hero.jpg" alt="Coordinated MEP model of an industrial facility" />
            {HERO_PINS.map((pin, i) => (
              <button
                key={pin.label}
                type="button"
                className={`pin${openPin === i ? ' open' : ''}`}
                style={{ left: `${pin.x}%`, top: `${pin.y}%` }}
                aria-label={pin.label}
                onClick={() => setOpenPin(openPin === i ? null : i)}
              >
                <span className="tip"><small>{pin.kicker}</small>{pin.label}</span>
              </button>
            ))}
            <div className="legend">Model → Coordinate → Deliver</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
